import { BrowserRouter, Route, Routes } from "react-router-dom";
import Site from "@/pages/site";
import AdminPage from "@/pages/admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
